//
// Collection PaymentBrand

import PaymentBrandModel from "./PaymentBrandModel";
import LocalStorageCollection from "../prototypes/LocalStorageCollection";

//

// @ts-ignore
class PaymentBrandCollection extends LocalStorageCollection<PaymentBrandModel> {
  name = "PaymentBrandCollection";
  route = "apiPaymentBrandCollection";
  idAttribute = "id_payment_brand";

  initialize(
    models?: Record<string, any>[] | PaymentBrandModel[],
    options?: any
  ): void {
    //   initialize() {
    // ObjectCollection constructor heritage

    super.initialize.apply(this, [models, options]);
    //
  }
  byIds(idBrands: Array<string | number> = []) {
    const filtered = this.filter(function (paymentBrand) {
      return idBrands.indexOf(paymentBrand.id) >= 0;
    });
    return new PaymentBrandCollection(filtered);
  }

  getHighestPriority() {
    let highestPriority = 0;
    this.each((paymentBrand) => {
      const priority = paymentBrand.get("priority") || 0;
      if (priority > highestPriority) {
        highestPriority = priority;
      }
    });
    return highestPriority;
  }
}

PaymentBrandCollection.prototype.model = PaymentBrandModel;
PaymentBrandCollection.prototype.name = "PaymentBrandCollection";
PaymentBrandCollection.prototype.route = "apiPaymentBrandCollection";
PaymentBrandCollection.prototype.model = PaymentBrandModel;
export default PaymentBrandCollection;
